import React, { Component } from 'react';
import RegionDetails from './RegionDetails.js';
import { withRouter } from '../../common/utils/NavigationWrapper';
import {
  getRegion,
  getUsersOfRegion,
  getInstrumentsOfRegion,
  updateRegion,
  getAssignableUsersToRegion,
  addUserToRegion,
  removeUserFromRegion,
} from './RegionDetails.actions';
import Loading from '../../common/components/Loading/Loading';
import Store from '../../redux/Store';
import { showSnackbar } from '../../common/state/snackbar/Snackbar.actions';
import Constants from '../../common/constants/Constants';
import Validators from '../../common/utils/Validators';

class RegionDetailsContainer extends Component {
  constructor() {
    super();
    this.state = {
      region: {},
      isFetching: false,
      users: [],
      assignableUsers: [],
      instruments: [],
      updateRegionErrorText: '',
      showAddUserDialog: { show: false, action: () => {}, cancel: () => {} },
      selectedUserId: null,
      showConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
        disableMainAction: false,
      },
      messageToConfirm: '',
    };
  }

  componentDidMount() {
    const { params } = this.props;
    let regionId = parseInt(params.id, 10);

    if (regionId) {
      this.setState({ isFetching: true }, () => this._loadData(regionId));
    }
  }

  _loadData = (regionId) => {
    let region = null;
    let users = null;
    let instruments = null;
    getRegion(regionId)
      .then((res) => {
        region = res.body;
        return getUsersOfRegion(regionId);
      })
      .then((res) => {
        users = res.body;
        return getInstrumentsOfRegion(regionId);
      })
      .then((res) => {
        if (JSON.stringify(res.body) === '[null,null]') {
          instruments = [];
        } else {
          instruments = res.body;
        }

        this.setState({
          region,
          users,
          instruments,
          isFetching: false,
        });
      });
  };

  render() {
    return (
      <Loading condition={this.state.isFetching}>
        <RegionDetails
          region={this.state.region}
          users={this.state.users}
          instruments={this.state.instruments}
          updateRegionErrorText={this.state.updateRegionErrorText}
          onChangeCallback={this._onChangeRegionName}
          onSubmitChangeRegionName={this._onSubmitChangeRegionName}
          showAddUserDialog={this.state.showAddUserDialog}
          openAddUserDialogCallback={this._openAddUserDialogCallback}
          selectedUserId={this.state.selectedUserId}
          handleSelectedUser={this._handleSelectedUser}
          assignableUsers={this.state.assignableUsers}
          onRemoveUserCallback={this._onRemoveUserCallback}
          showConfirmDialog={this.state.showConfirmDialog}
          messageToConfirm={this.state.messageToConfirm}
        />
      </Loading>
    );
  }

  _openAddUserDialogCallback = () => {
    getAssignableUsersToRegion(this.state.region.RegionId)
      .then((res) => {
        this.setState({
          assignableUsers: res.body,
          showAddUserDialog: {
            show: true,
            title: 'Add user to region',
            action: this._addUser,
            cancel: this._cancelAddUser,
          },
        });
      })
      .catch((err) => this._showFailMessage('Error occured while adding user.'));
  };

  _addUser = () => {
    if (this.state.selectedUserId != null) {
      addUserToRegion(this.state.region.RegionId, this.state.selectedUserId)
        .then((res) => {
          return getUsersOfRegion(this.state.region.RegionId);
        })
        .then((res) => {
          this.setState({
            users: res.body,
            selectedUserId: null,
            showAddUserDialog: {
              show: false,
              action: () => {},
              cancel: () => {},
            },
          });
        })
        .then((res) => {
          this._showSuccesMessage('User successfully assigned to region.');
        })
        .catch((err) => this._showFailMessage('', err));
    }
  };

  _cancelAddUser = () => {
    this.setState({
      selectedUserId: null,
      showAddUserDialog: { show: false, action: () => {}, cancel: () => {} },
    });
  };

  _handleSelectedUser = (event) => {
    this.setState({ selectedUserId: event });
  };

  _onChangeRegionName = (propertyName, value) => {
    let newRegion = {
      ...Object.assign({}, this.state.region),
      [propertyName]: value,
    };

    this.setState((prevState) => ({
      region: newRegion,
      updateRegionErrorText:
        prevState.region.Name != newRegion.Name
          ? this._getValidationErrorMessage(value)
          : prevState.updateRegionErrorText,
    }));
  };

  _getValidationErrorMessage = (value) => {
    let validationMessage = '';
    if (!Validators.validateStringBetweenRange(value, 1, 200)) {
      validationMessage =
        'Enter an alphanumeric value between 1 and 200 characters; for example: Region 01';
    }
    return validationMessage;
  };

  _onSubmitChangeRegionName = () => {
    if (this.state.region.Name) {
      let updatedRegion = {};
      updateRegion(this.state.region)
        .then((res) => {
          updatedRegion = res.body;
          this.setState(
            {
              region: updatedRegion,
            },
            () => this._showSuccesMessage('Successfully updated.')
          );
        })
        .catch((err) => this._showFailMessage('', err));
    } else {
      this._showFailMessage('Empty region name or similar region name already exists!');
    }
  };

  _onRemoveUserCallback = (user) => {
    this.setState({
      messageToConfirm: `Are you sure you want to remove user "${user.Username}" from "${this.state.region.Name}"?`,
      showConfirmDialog: {
        title: `Remove user ${user.Username}`,
        show: true,
        action: () => this._onConfirmRemoveUser(user),
        cancel: this._onCancelRemoveUser,
        mainActionLabel: 'Yes',
      },
    });
  };

  _onConfirmRemoveUser = (user) => {
    if (user) {
      this.setState({ showConfirmDialog: { disableMainAction: true } });
      removeUserFromRegion(this.state.region.RegionId, user.UserEntityId)
        .then((res) => {
          return getUsersOfRegion(this.state.region.RegionId);
        })
        .then((res) => {
          this.setState({
            users: res.body,
            selectedUserId: null,
            messageToConfirm: '',
            showConfirmDialog: {
              show: false,
              disableMainAction: false,
              action: () => {},
              cancel: () => {},
            },
          });
          this._showSuccesMessage('Successfully removed.');
        })
        .catch((err) => this._showFailMessage('Could not remove user. '));
    }
  };

  _onCancelRemoveUser = () => {
    this.setState({
      messageToConfirm: '',
      showConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
        disableMainAction: false,
      },
    });
  };

  _showSuccesMessage(theMessage) {
    Store.dispatch(
      showSnackbar({
        type: Constants.SNACKBAR_MESSAGE_TYPES.SUCCESS,
        message: theMessage,
      })
    );
  }

  _showFailMessage(theMessage, err) {
    let messageToShow = theMessage;
    if (err != null) {
      messageToShow +=
        err.response && err.response.body.Message
          ? err.response.body.Message
          : Constants.DEFAULT_ERROR_MESSAGE;
    }

    Store.dispatch(
      showSnackbar({
        type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
        message: messageToShow,
      })
    );
  }
}

export default withRouter(RegionDetailsContainer);
